import icons from '../icons/google_map.js'
import lang_code from '../gb-helper/language_code'

const { registerBlockType } = wp.blocks;
const { __ } = wp.i18n;
const { InspectorControls} = wp.editor;
const { PanelBody, RangeControl, TextControl, SelectControl,Button,PanelRow,Dashicon,Card,CardBody } = wp.components;

registerBlockType('blocksbakery/google-map', {
    title: __('Google map', 'blocks-bakery'),
    description: __(
        'Google Maps block is capable of displaying locations with zoom options as well as Blocks bakery.',
        'blocks-bakery'
    ),
    // common, formatting, layout, widgets, embed
    category: 'blocks-bakery',
    icon: icons.flat_icon,
    keywords: [
        __('Map', 'blocks-bakery'),
        __('Google', 'blocks-bakery')
    ],
    "attributes": {
        "zoom_map": {
            "type": "number",
            "default": 15
        },
        "height_map": {
            "type": "number",
            "default": 300,
        },
        "address": {
            "type": "string",
            "default": "damn e koh"
        },
        "lang_code": {
            "type": "string",
            "default": "en"
        },
        "googlemap_style": {
            "source": "attribute",
            "attribute": "style"
        },
        "css_brightness": {
            "type":  "number",
            "default": 100
        },
        "css_contrast": {
            "type":  "number",
            "default": 100
        },
        "css_saturation": {
            "type":  "number",
            "default": 100
        },
        "css_hue": {
            "type":  "number",
            "default": 0,
        },
        "css_blur":{
            'type' : 'number',
            'default' : 0,
        },


        //New for today

        "height_max_min":{
            "type":"number",
            "default":"100",
        },
        "heigphtpxvh":{
            "type":"string",
            "default":"vh"
        },
        
        //for hover filter 

        "css_hover_brightness": {
            "type": "number",
            "default": 100
        },
        "css_hover_contrast": {
            "type": "number",
            "default": 100
        },
        "css_hover_saturation": {
            "type": "number",
            "default": 100
        },
        "css_hover_hue": {
            "type": "number",
            "default": 0,
        },
        "css_hover_blur": {
            "type": "number",
            "default": 0,
        },
        
    },

    edit: (props) => {

        const cssfilter_toggle = () => {
            var x = document.getElementById("cssfilter_toggle")
            console.log("open")

            if (x.style.display === "block") {
                x.style.display = "none"
            }
            else if (x.style.display === "none") {
                x.style.display = "block"
            }
        }
        const cssfilter_remove = () => {
            props.setAttributes({ css_blur: 0 })
            props.setAttributes({ css_brightness: 100 })
            props.setAttributes({ css_contrast: 100 })
            props.setAttributes({ css_hue: 0 })
            props.setAttributes({ css_saturation: 100 })

        }

        //For Responsive Devices...

        const laptop = () => {
            wp.data.dispatch('core/edit-post').__experimentalSetPreviewDeviceType('Device');
        }
        const tablet = () => {
            wp.data.dispatch('core/edit-post').__experimentalSetPreviewDeviceType('Tablet');
        }
        const smartphone = () => {
            wp.data.dispatch('core/edit-post').__experimentalSetPreviewDeviceType('Mobile');
        }

        //End of the Responsive Devices...

        //For height change the unitex

        const heightpx = () =>{
            var x = document.getElementById("heightpx");
            var y = document.getElementById("heightvh");
            x.style.textDecoration="underline";
            y.style.textDecoration = "none"
            props.setAttributes({heigphtpxvh:'px'})
            props.setAttributes({height_max_min:'1440'})
        }
        const heightvh = () =>{
            var x = document.getElementById("heightpx");
            var y = document.getElementById("heightvh");
            x.style.textDecoration="none";
            y.style.textDecoration = "underline"
            props.setAttributes({heigphtpxvh:'vh'})
            props.setAttributes({height_max_min:'100'})
        }

        //For For hover oopacity..

        const clearImgBorderColor = () => { props.setAttributes({ image_border_color: "" }) }
        const clearImgShadowColor = () => { props.setAttributes({ img_shadow_color: '' }) }
        const clearImgShadowHoverColor = () => {  props.setAttributes({ img_hover_shadow_blur: '' }) }
    
        // Reset
    
        const imgShadowReset = () => {
            props.setAttributes({ img_shadow_horizontal: 0 })
            props.setAttributes({ img_shadow_vertical: 0 })
            props.setAttributes({ img_shadow_color: '' })
            props.setAttributes({ img_shadow_blur: 0 })
        }
        const filter_edit_panel_reset = () => {
            props.setAttributes({ css_blur: 0 })
            props.setAttributes({ css_brightness: 100 })
            props.setAttributes({ css_contrast: 100 })
            props.setAttributes({ css_hue: 0 })
            props.setAttributes({ css_saturation: 100 })
        }
        const imgFilterHoverResetPanel = () => {
            props.setAttributes({ css_hover_blur: 0 })
            props.setAttributes({ css_hover_brightness: 100 })
            props.setAttributes({ css_hover_contrast: 100 })
            props.setAttributes({ css_hover_hue: 0 })
            props.setAttributes({ css_hover_saturation: 100 })
        }
    
        const imgHover = (e) => {
            const hover = e.target.style;
     
            hover.filter = `brightness(${ props.attributes.css_hover_brightness}%) contrast(${ props.attributes.css_hover_contrast}%) saturate(${ props.attributes.css_hover_saturation}%) blur(${ props.attributes.css_hover_blur}px) hue-rotate(${ props.attributes.css_hover_hue}deg)`
      
    
        }
        const imgNormal = (e) => {
            const normal = e.target.style;

            normal.filter = `brightness(${props.attributes.css_brightness}%) contrast(${props.attributes.css_contrast}%) saturate(${props.attributes.css_saturation}%) blur(${props.attributes.css_blur}px) hue-rotate(${props.attributes.css_hue}deg)`;
           
        }
        const imgFilterEditPanel = () => {
            var filter_edit_panel = document.getElementById("img_filter_edit_panel");
            var filter_reset_display = document.getElementById("filter_reset_display");
            filter_reset_display.style.display = "inline-block"
            if (filter_edit_panel.style.display === "block") {
                filter_edit_panel.style.display = "none"
            }
            else if (filter_edit_panel.style.display === "none") {
                filter_edit_panel.style.display = "block";
            }
        }
        const imgFilterHoverEditPanel = () => {
            var filter_edit_panel = document.getElementById("img_hover_filter_edit_panel");
            var filter_reset_display = document.getElementById("filter_hover_reset_display");
            filter_reset_display.style.display = "inline-block"
            if (filter_edit_panel.style.display === "block") {
                filter_edit_panel.style.display = "none"
            }
            else if (filter_edit_panel.style.display === "none") {
                filter_edit_panel.style.display = "block";
            }
        }
        

        //end of the hover......
        return (
            <div>
                <InspectorControls>
                    <PanelBody title={__('General', 'blocks-bakery')} initialOpen={true}>
                        <TextControl
                            label="Address"
                            value={props.attributes.address}
                            onChange={(new_val) => {
                                props.setAttributes({ address: new_val })
                            }}
                        />
                        <div className="range-controler" style={{display:"flex"}}>
                        <div style={{marginRight:"10px",width:"100%"}}>
                        <RangeControl
                            label="Zoom"
                            min={1}
                            max={22}
                            step={0.1}
                            initialPosition={15}
                            value={props.attributes.zoom_map}
                            onChange={(new_val) => {
                                props.setAttributes({ zoom_map: new_val })
                            }}
                        />
                           </div>
                        <Button style={{
                        background: 'transparent', border: '1px solid #007cba', fontSize: '11px',width:"22%",height:"31px",color:"#007cba", marginTop:"25px"
                        }}
                        onClick={() => {
                        props.setAttributes({zoom_map:15})
                        }}> Reset 
                        </Button>
                        </div>


                        {/* //for label of heaight */}

                        <br/>
                        <PanelRow> 
                      
                            <div>
                                <span style={{marginRight:10}}>Height</span>
                                <Dashicon style={{ cursor: 'pointer' }} onClick={laptop} icon='laptop' />
                                <Dashicon style={{ cursor: 'pointer' }} onClick={tablet} icon='tablet' />
                                <Dashicon style={{ cursor: 'pointer' }} onClick={smartphone} icon='smartphone' />
                            </div>

                            <div>
                            <Button id="heightpx" onClick={heightpx} style={{  padding: 0, boxShadow: "none", textTransform: "uppercase", fontSize: 10, marginRight: 5 }}>px</Button>
                            <Button id="heightvh" onClick={heightvh} style={{textDecoration: "underline", padding: 0, boxShadow: "none", textTransform: "uppercase", fontSize: 10, marginRight: 5 }}>vh</Button>
                        </div>
                        </PanelRow>



                        {/* end of the height  label*/}
                        <div className="range-controler" style={{display:"flex",justifyContent:"center"}}>
                        <div style={{marginRight:"10px",width:"100%"}}>
                        <RangeControl
                         
                            min={10}
                            max={props.attributes.height_max_min}
                            initialPosition={100}
                            step={0.1}
                            value={props.attributes.height_map}
                            onChange={(new_val) => {
                                props.setAttributes({ height_map: new_val })
                            }}
                        />
                           </div>
                        <Button style={{
                        background: 'transparent', border: '1px solid #007cba', fontSize: '11px',width:"22%",height:"31px",color:"#007cba", 
                        }}
                        onClick={() => {

                        props.setAttributes({height_map:100})
                        }}> Reset 
                        </Button>
                        </div>
                        
                        <SelectControl
                            label={__("Language", 'Google Map')}
                            value={props.attributes.lang_code}
                            options={lang_code}
                            onChange={(new_val) => { 
                                props.setAttributes({ lang_code: new_val })
                            }}
                        />
                    </PanelBody>

                   <PanelBody title={(__("Map","blocks-bakery"))}>
                       
                   <PanelRow>
                            <p>CSS Filter</p>
                            <div>
                                <Button onClick={cssfilter_remove} style={{ paddingLeft: 7, paddingRight: 7 }}><span><Dashicon icon="image-rotate" style={{ fontSize: 15 }} /></span></Button>
                                <Button onClick={cssfilter_toggle} style={{ paddingLeft: 7, paddingRight: 7 }}><span><Dashicon icon="admin-tools" style={{ fontSize: 15 }} /></span></Button>
                            </div>
                        </PanelRow>
                        <Card id="cssfilter_toggle" style={{ display: "none" }}>
                            <CardBody style={{ paddingTop: 16, paddingBottom: 16, paddingLeft: 10, paddingRight: 10 }}>

                                <RangeControl
                                    label="Blur"
                                    min={0}
                                    max={10}
                                    initialPosition={0}
                                    value={props.attributes.css_blur}
                                    onChange={(new_val) => {
                                        props.setAttributes({ css_blur: new_val })
                                    }}

                                />

                                <RangeControl
                                    label="Brightness"
                                    min={0}
                                    max={200}
                                    initialPosition={100}
                                    value={props.attributes.css_brightness}
                                    onChange={(new_val) => {
                                        props.setAttributes({ css_brightness: new_val })
                                    }}

                                />

                                <RangeControl
                                    label="Contrast"
                                    min={0}
                                    max={200}
                                    initialPosition={100}
                                    value={props.attributes.css_contrast}
                                    onChange={(new_val) => {
                                        props.setAttributes({ css_contrast: new_val })
                                    }}

                                />

                                <RangeControl
                                    label="Saturation"
                                    min={0}
                                    max={200}
                                    initialPosition={100}
                                    value={props.attributes.css_saturation}
                                    onChange={(new_val) => {
                                        props.setAttributes({ css_saturation: new_val })
                                    }}

                                />

                                <RangeControl
                                    label="Hue"
                                    min={0}
                                    max={360}
                                    initialPosition={0}
                                    value={props.attributes.css_hue}
                                    onChange={(new_val) => {
                                        props.setAttributes({ css_hue: new_val })
                                    }}

                                />


                            </CardBody>
                        </Card>


                   </PanelBody>
            

            <PanelBody title={__("Hover", 'blocks-bakery')}>
            
            <PanelRow>
                        <p>Image Hover Filters</p>
                        <div>
                            <Button onClick={imgFilterHoverResetPanel} id="filter_hover_reset_display" style={{ display: 'none', paddingLeft: 7, paddingRight: 7 }}><span><Dashicon icon="image-rotate" style={{ fontSize: 15 }} /></span></Button>
                            <Button onClick={imgFilterHoverEditPanel} style={{ textDecoration: "underline", paddingLeft: 7, paddingRight: 7 }}><span><Dashicon icon="edit" style={{ fontSize: 15 }} /></span></Button>
                        </div>
                    </PanelRow>
                    <Card id="img_hover_filter_edit_panel" style={{ display: "none" }}>
                        <CardBody style={{ paddingTop: 16, paddingBottom: 16, paddingLeft: 10, paddingRight: 10 }}>
                            <RangeControl
                                label="Blur"
                                min={0}
                                max={10}
                                initialPosition={0}
                                value={props.attributes.css_hover_blur}
                                onChange={(new_val) => {
                                    props.setAttributes({ css_hover_blur: new_val })
                                }}
                            />
                            <RangeControl
                                label="Brightness"
                                min={0}
                                max={200}
                                initialPosition={100}
                                value={props.attributes.css_hover_brightness}
                                onChange={(new_val) => {
                                    props.setAttributes({ css_hover_brightness: new_val })
                                }}
                            />
                            <RangeControl
                                label="Contrast"
                                min={0}
                                max={200}
                                initialPosition={100}
                                value={props.attributes.css_hover_contrast}
                                onChange={(new_val) => {
                                    props.setAttributes({ css_hover_contrast: new_val })
                                }}
                            />
                            <RangeControl
                                label="Saturation"
                                min={0}
                                max={200}
                                initialPosition={100}
                                value={props.attributes.css_hover_saturation}
                                onChange={(new_val) => {
                                    props.setAttributes({ css_hover_saturation: new_val })
                                }}
                            />
                            <RangeControl
                                label="Hue"
                                min={0}
                                max={360}
                                initialPosition={0}
                                value={props.attributes.css_hover_hue}
                                onChange={(new_val) => {
                                    props.setAttributes({ css_hover_hue: new_val })
                                }}
                            />
                        </CardBody>
                    </Card>
                    <hr />
            </PanelBody>
            
            
                </InspectorControls>
                <div>
                  <iframe className="bb-google-map"
                     style={{
                     
                         
                         filter: `brightness(${props.attributes.css_brightness}%) contrast(${props.attributes.css_contrast}%) saturate(${props.attributes.css_saturation}%) blur(${props.attributes.css_blur}px) hue-rotate(${props.attributes.css_hue}deg)`,
                         height:props.attributes.height_map+props.attributes.heigphtpxvh
                        
                        }} 
                        onMouseOver={imgHover}
                        onMouseLeave={imgNormal}
                     src={`https://www.google.com/maps/embed/v1/place?key=AIzaSyA-1FeCwOmIay86tOgg-NIejXLmHKqKVzA&q=${props.attributes.address}&zoom=${props.attributes.zoom_map}&language=${props.attributes.lang_code}`}>
                    </iframe>
                </div>
            
            </div>
        )
    },
    save: (props) => {
        return (null)
    }
})
